import React, { Component } from 'react';
import {
  WatchlistBaseModel,
  WatchlistEntityRequest,
  WatchlistGeneralRequest,
  WatchlistIndividualRecord,
  WatchlistIndividualRequest,
  WatchlistListsModel,
  WatchlistNameModel,
  WatchlistNameType,
} from '../../../domain/watchlist/WatchlistDomains';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState, store } from '../../../redux/store';
import { changeWatchlist } from '../../../redux/actions/WatchlistActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import CustomLoading from '../../custom/CustomLoading';
import Breadcrumb from '../../Breadcrumb';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import moment from 'moment';
import CustomTabv2 from '../../custom/CustomTabv2';
import WatchlistInformationComponent from './WatchlistInformationComponent';
import WatchlistNewsComponent from './WatchlistNewsComponent';
import _ from 'lodash';
import { WatchlistType } from '../../../constant/Constants';
import WatchlistSearchCriteriaModalComponent from '../detail/modal/WatchlistSearchCriteriaModalComponent';
import { PDFDownloadLink } from '@react-pdf/renderer';
import WatchlistReportComponent from '../detail/pdf/WatchlistReportComponent';
import Icon from '../../../icons/Icon';
import { ConfirmPopup } from 'primereact/confirmpopup';
import WatchlistLevelModalComponent from '../detail/modal/WatchlistLevelModalComponent';
import LanguageUtil from '../../../util/LanguageUtil';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import CollectionNames from '../../../constant/CollectionNames';
import { MatchManyLog } from '../../../domain/watchlist/WatchlistHistoryDomains';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;

class WatchlistDetailComponent extends Component<Props, State> {
  public state: State = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private historySubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;
  private historyLoaded: boolean = false;

  public render() {
    const { selectedResponse, request, date, searchCriteriaVisible, levelVisible, watchlistResponse, type } = this.state;
    if (selectedResponse == undefined) {
      return <CustomLoading />;
    }
    return (
      <div className='w-full h-full flex flex-col'>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'p-5'}>
          <div className={'flex justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE]'
              >
                {this.getImage()}
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>{this.getName()}</span>
                <div className={'flex items-center gap-x-2'}>
                  {this.getCategory()?.map((value: string, index: number) => {
                    return (
                      <span
                        key={index}
                        className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center px-[8px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                      >
                        {value}
                      </span>
                    );
                  })}
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {date}
                  </span>
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] bg-[#DBFFEA] text-[#027A48]`}
                  >
                    {selectedResponse.score || 0}/100
                  </span>
                  {selectedResponse?.level != undefined && (
                    <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ levelVisible: true })}>
                      <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                        {LanguageUtil.get({ id: 'common.label.level', defaultMessage: 'Level' })}
                      </span>
                    </div>
                  )}
                  <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ searchCriteriaVisible: true })}>
                    <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                      {LanguageUtil.get({ id: 'common.label.searchCriteria', defaultMessage: 'Search Criteria' })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={'flex gap-x-2 items-center justify-center'}>
              <PDFDownloadLink
                document={
                  <WatchlistReportComponent
                    selectedResponse={selectedResponse}
                    watchlistResponse={watchlistResponse}
                    type={type as WatchlistType}
                    name={this.getName()}
                    request={request}
                  />
                }
                fileName='watchlist.pdf'
              >
                {({ blob }) => {
                  if (blob) {
                    return (
                      <div
                        style={{ boxShadow: '1px 1px 2px 0px #0000000D' }}
                        className={`cursor-pointer relative hover:bg-[#EDEDED] group w-10 h-10 box-border flex items-center justify-center rounded-[5px] border-[1px]`}
                      >
                        <Icon icon={'export'} className={'text-f-black-2'} size={20} />
                        <p
                          className={
                            'hidden group-hover:inline-flex absolute top-[-40px] w-[85px] items-center justify-center right-0 bg-[#111111]  shrink-0 text-white px-2 py-2 rounded-[8px]'
                          }
                        >
                          {LanguageUtil.get({ id: 'common.label.report', defaultMessage: 'Report' })}
                        </p>
                      </div>
                    );
                  }
                }}
              </PDFDownloadLink>
            </div>
          </div>
        </div>
        <div className={'flex w-full h-full'}>
          <CustomTabv2 tab={this.getTabs()} />
        </div>
        <WatchlistSearchCriteriaModalComponent
          visible={searchCriteriaVisible}
          request={request}
          onClose={() => this.setState({ searchCriteriaVisible: false })}
        />
        <WatchlistLevelModalComponent
          visible={levelVisible}
          level={selectedResponse?.level}
          type={type}
          onClose={() => this.setState({ levelVisible: false })}
        />
      </div>
    );
  }

  public async componentDidMount() {
    this.getRequest();
    await this.isPagePathNotInitialized();
    await this.getLists();
    await this.getWatchlist();
  }

  public async componentWillUnmount() {
    await this.historySubscription?.stop();
    this.computation?.stop();
  }

  private isPagePathNotInitialized = async () => {
    const { router } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
    }
  };

  private getLists = async () => {
    try {
      const lists: WatchlistListsModel[] | undefined = await this.watchlistService.getLists();
      this.setState({ watchlistResponse: lists || [] });
    } catch (e) {
      console.error(e);
    }
  };

  private getWatchlist = async () => {
    const { recordId, type, logId } = this.calculateUrl();
    if (type == undefined || type == null || recordId == undefined || recordId == null) {
      return;
    }
    if (logId != undefined && logId != null) {
      this.startHistoryTracker(logId);
      return;
    }
    await this.getWatchlistById(type, recordId);
  };

  private getHistoryQuery = (logId: string): query.Query => {
    return QueryBuilder.select().from(CollectionNames.MATCH_MANY_LOGS).where(eq('id', logId)).build();
  };

  private startHistoryTracker = (logId: string) => {
    this.historySubscription = subscribe.Formica.subscribe(CollectionNames.MATCH_MANY_LOGS, this.getHistoryQuery(logId));
    this.computation = subscribe.Tracker.autorun(() => this.historyTracker(logId), [this.historySubscription]);
  };

  private historyTracker = async (logId: string) => {
    if (!this.historySubscription?.ready() || this.historyLoaded) {
      return;
    }
    this.historyLoaded = true;
    const { recordId, type } = this.calculateUrl();
    if (type == undefined || type == null || recordId == undefined || recordId == null) {
      return;
    }
    const log: MatchManyLog | undefined = await this.repository.find(this.getHistoryQuery(logId));
    const match: WatchlistBaseModel | undefined = log?.matches?.find((item: WatchlistBaseModel) => item.record.id == recordId);
    if (log == undefined || match == undefined) {
      await this.getWatchlistById(type, recordId);
      return;
    }
    this.setState({
      type,
      selectedResponse: match,
      date: moment(Number(log.createdAt)).format('DD/MM/yyyy HH:mm').valueOf(),
    });
  };

  private getWatchlistById = async (type: string, recordId: string) => {
    const { score, level } = this.calculateUrl();
    try {
      const recordResponse = await this.watchlistService.getById(type as WatchlistType, recordId);
      if (recordResponse.error || recordResponse.data == undefined) {
        return;
      }
      const response: WatchlistBaseModel = {
        score: parseInt(score as string),
        level: level ? parseInt(level as string) : undefined,
        record: recordResponse.data.data,
      };
      this.setState({ type, selectedResponse: response });
    } catch (e) {
      console.error(e);
    }
  };

  private getRequest = () => {
    const {
      type,
      name,
      phone,
      email,
      lists,
      citizenship,
      dateOfBirth,
      dateOfRegistration,
      threshold,
      identifier,
      identification,
      date,
      id,
      referenceId,
    } = this.calculateUrl();
    const parsedThreshold = threshold != null && threshold !== '' ? Number(threshold) : 50;
    let request: WatchlistEntityRequest | WatchlistIndividualRequest | WatchlistGeneralRequest | undefined = undefined;
    if (type == 'Individual') {
      request = {
        id: null,
        threshold: parsedThreshold,
        name: name,
        email: email,
        phone: phone,
        dateOfBirth: dateOfBirth,
        citizenship: citizenship,
        identification: identification,
        referenceId: referenceId,
        lists: lists && lists.length > 0 ? lists.split(',') : [],
      };
    } else if (type == 'Entity') {
      request = {
        id: null,
        threshold: parsedThreshold,
        name: name,
        email: email,
        phone: phone,
        dateOfRegistration: dateOfRegistration,
        identifier: identifier,
        referenceId: referenceId,
        lists: lists && lists.length > 0 ? lists.split(',') : [],
      };
    } else if (type == 'General') {
      request = {
        threshold: parsedThreshold,
        name: name,
        email: email,
        phone: phone,
        date: date,
        id: id,
        referenceId: referenceId,
        lists: lists && lists.length > 0 ? lists.split(',') : [],
      };
    }
    this.setState({ request, date: moment().format('DD/MM/yyyy HH:mm').valueOf() });
  };

  private calculateUrl = () => {
    const {
      router: { params },
    } = this.props;
    const previousSearchParams = new URLSearchParams(params.id);
    return {
      type: previousSearchParams.get('type'),
      threshold: previousSearchParams.get('threshold'),
      lists: previousSearchParams.get('lists'),
      email: previousSearchParams.get('email'),
      phone: previousSearchParams.get('phone'),
      dateOfBirth: previousSearchParams.get('dateOfBirth'),
      citizenship: previousSearchParams.get('citizenship'),
      name: previousSearchParams.get('name'),
      dateOfRegistration: previousSearchParams.get('dateOfRegistration'),
      recordId: previousSearchParams.get('recordId'),
      logId: previousSearchParams.get('logId'),
      score: previousSearchParams.get('score'),
      level: previousSearchParams.get('level'),
      identifier: previousSearchParams.get('identifier'),
      identification: previousSearchParams.get('identification'),
      id: previousSearchParams.get('id'),
      date: previousSearchParams.get('date'),
      referenceId: previousSearchParams.get('referenceId'),
    };
  };

  private getName = (): string => {
    const { selectedResponse } = this.state;
    if (selectedResponse === undefined) return 'Name Undefined';
    const flattenedArray: WatchlistNameModel[][] =
      selectedResponse.record?.records?.map((value) => {
        return value.watchlistRecord.names;
      }) || [];
    const namesData: WatchlistNameModel[] = ([] as WatchlistNameModel[]).concat(...flattenedArray);
    if (namesData.length === 0) return LanguageUtil.get({ id: 'common.label.nameUndefined', defaultMessage: 'Name Undefined' });
    const longestPrimaryData: WatchlistNameModel[] = namesData.filter((item: WatchlistNameModel) => item.nameType === WatchlistNameType.PRIMARY);
    if (longestPrimaryData.length === 0) return namesData[0].value;
    const data: WatchlistNameModel = longestPrimaryData.reduce((a, b) => (a.value.length > b.value.length ? a : b));
    return data.value;
  };

  private getCategory = (): string[] | undefined => {
    const { selectedResponse } = this.state;
    if (selectedResponse == undefined) return undefined;
    const categories: string[][] = [];
    selectedResponse.record.records.forEach((response) => {
      categories.push(response.watchlistRecord.categories);
    });
    return _.uniqBy([].concat(...categories) as string[], (value) => value);
  };

  private getImage = () => {
    const { selectedResponse } = this.state;
    if (selectedResponse) {
      if (selectedResponse.record.recordType == 'INDIVIDUAL') {
        const images = selectedResponse?.record?.records.filter(
          (record) => (record.watchlistRecord as WatchlistIndividualRecord).images && (record.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
        );
        if (images != undefined && images.length > 0) {
          return (
            <img
              src={(images[0].watchlistRecord as WatchlistIndividualRecord).images[0]}
              alt='-'
              onClick={() => window.open((images[0].watchlistRecord as WatchlistIndividualRecord).images[0], '_blank')}
              className={
                'w-[60px] h-[60px] cursor-pointer border min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] object-cover'
              }
            />
          );
        }
        return <img src={'/icons/individual.svg'} alt='individual' />;
      } else {
        return <img src={'/icons/entity.svg'} alt='entity' />;
      }
    }
  };

  protected getTabs = () => {
    const { selectedResponse, watchlistResponse, type } = this.state;
    return [
      {
        key: 'Information',
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.table.information', defaultMessage: 'Information' }),
        content: (
          <WatchlistInformationComponent
            selectedResponse={selectedResponse?.record.records || []}
            watchlistResponse={watchlistResponse}
            type={type as WatchlistType}
          />
        ),
      },
      {
        key: 'News',
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.table.news', defaultMessage: 'News' }),
        content: <WatchlistNewsComponent />,
      },
    ];
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  watchlist: state.watchlist,
});
const mapDispatchToProps = { changeWatchlist };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  searchCriteriaVisible: boolean = false;
  levelVisible: boolean = false;
  selectedResponse: WatchlistBaseModel | undefined;
  type: string | undefined | null;
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined;
  date: string | undefined;
  watchlistResponse: WatchlistListsModel[] = [];
}

export default withFormica(connector(WatchlistDetailComponent));
